import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'legitimateInterest'
})
export class LegitimateInterestPipe implements PipeTransform {

  transform(interest): string {
    interest = this.cleanString(interest);
    switch(interest) {
      case "owner": {
         return "als Eigentümer";
      }
      case "authorized": {
        return "als Bevollmächtige/r";
      }
      default: {
       return "";
      }
    }
  }

  cleanString(s): string{
   return s.replaceAll("\"", "");
  }

}
